import type { AxiosResponse } from "axios"
import { HTTPMethods, HTTPRequestBuilder } from "@/builder/HTTPRequestBuilder"
import { BaseRepository } from "@/repositories/base-repository"
import type { IWorkspaceChecklistItem } from "@/workspace/interfaces/api/workspace-checklist-item.interface"
import type { IRepositoryRequestConfig } from "@/interfaces/repository/repository-request-config.interface"

export class WorkspaceChecklistItemRepository extends BaseRepository<IWorkspaceChecklistItem> {
  protected resourcePath = "workspace/checklist-items"

  public async complete(
    id: string,
    config: IRepositoryRequestConfig = {}
  ): Promise<AxiosResponse<IWorkspaceChecklistItem>> {
    return await this.setCompletion(id, "complete", config)
  }

  public async reopen(
    id: string,
    config: IRepositoryRequestConfig = {}
  ): Promise<AxiosResponse<IWorkspaceChecklistItem>> {
    return await this.setCompletion(id, "reopen", config)
  }

  private async setCompletion(
    id: string,
    action: "complete" | "reopen",
    config: IRepositoryRequestConfig
  ): Promise<AxiosResponse<IWorkspaceChecklistItem>> {
    return await new HTTPRequestBuilder(
      HTTPMethods.POST,
      `${this.getResourcePath(id, config)}${action}/`
    )
      .setData({})
      .query(config.query)
      .setbeforeErrorHandlingCallback(config.beforeErrorHandlingCallback)
      .addStatusCodeHandlers(config.statusCodeHandlers)
      .build()
      .execute()
  }
}
